import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  ButtonToolbar,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  checkPermision,
  clearValues,
  formLabelsTheme,
  getValueType,
  iconError,
  optionsStatus,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";

import {
  fetchActivity,
  selectActivity,
  resetData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchActivityDetail,
  selectActivityDetail,
} from "./activitySlice";

import { FormHelperText } from "@material-ui/core";
import { ModalClientRadio } from "./ModalClientRadio";
import { ModalPartyRadio } from "./ModalPartyRadio";
import { MonitorTable } from "./MonitorTable";
import { ModalColorRadio } from "../modalfilter/ModalColorRadio";
import { ModalProductRadio } from "../modalfilter/ModalProductRadio";
import { ModalModelRadio } from "../modalfilter/ModalModelRadio";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const MonitorPage = (params) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectActivityDetail);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();
  const dataMenuTab = useSelector(selectMenuTab);

  const dataParams = params.location.state;

  const [typeParty, setTypeParty] = useState("");
  const [typePartyName, setTypePartyName] = useState("");
  const [getData, setGetData] = useState(false);
  const [getDataClient, setGetDataClient] = useState(false);

  const [showClient, setShowClient] = useState(false);
  const [showShipper, setShowShipper] = useState(false);

  // modal filter
  const [showModel, setShowModel] = useState(false);
  const [showColor, setShowColor] = useState(false);
  const [showProduct, setShowProduct] = useState(false);
  const [getDataFilter, setGetDataFilter] = useState(false);

  const [fieldsFilter, setFieldsFilter] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  // Filter
  const [formValues, setFormValues] = useState({
    client: {
      value: "",
      error: false,
      required: "N",
    },
    shipper: {
      value: "",
      error: false,
      required: "N",
    },
    consigne: {
      value: "",
      error: false,
      required: "N",
    },

    workshop: {
      value: "",
      error: false,
      required: "N",
    },

    factory: {
      value: "",
      error: false,
      required: "N",
    },
    job_date_start: {
      value: "",
      error: false,
      required: "N",
    },
    job_date_end: {
      value: "",
      error: false,
      required: "N",
    },
    eta_start: {
      value: "",
      error: false,
      required: "N",
    },
    eta_end: {
      value: "",
      error: false,
      required: "N",
    },
    etd_start: {
      value: "",
      error: false,
      required: "N",
    },
    etd_end: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      const params = {
        is_enable: "Y",
        pageNo: 1,
        pageSize: paginationSet,
        process_type: dataParams,
      };

      await callApi(params);
    }
    fetchMyAPI();
  }, [dispatch]);

  const callApi = async (params) => {
    try {
      const response = await dispatch(fetchActivityDetail(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleSearch = async () => {
    let params = {
      pageNo: 1,
      pageSize: paginationSet,
      process_type: dataParams,
      client: formValues.client.value,
      shipper: formValues.shipper.value,
      consigne: formValues.consigne.value,
      workshop: formValues.workshop.value,
      factory: formValues.factory.value,
      job_date_start: formValues.job_date_start.value,
      job_date_end: formValues.job_date_end.value,
      etd_start: formValues.etd_start.value,
      etd_end: formValues.etd_end.value,
      eta_start: formValues.eta_start.value,
      eta_end: formValues.eta_end.value,
    };

    fields.forEach((item) => {
      params[item.params] = item.value;
    });

    try {
      const response = await dispatch(fetchActivityDetail(params));
      console.log(response, "response");
      if (response.payload.data.status === 200) {
        console.log("if");
      } else {
        console.log("else");
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log("else");
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {
        pageNo: page,
        pageSize: sizePerPage,
        process_type: dataParams,
        client: formValues.client.value,
        shipper: formValues.shipper.value,
        consigne: formValues.consigne.value,
        workshop: formValues.workshop.value,
        factory: formValues.factory.value,
        job_date_start: formValues.job_date_start.value,
        job_date_end: formValues.job_date_end.value,
        etd_start: formValues.etd_start.value,
        etd_end: formValues.etd_end.value,
        eta_start: formValues.eta_start.value,
        eta_end: formValues.eta_end.value,
      };
      fields.forEach((item) => {
        params[item.params] = item.value;
      });

      try {
        const response = await dispatch(fetchActivityDetail(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  // Parameter

  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",
      value: "vin",
      label: "VIN",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "von",
      label: "VON",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "model_code",
      label: "Model Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "model_name",
      label: "Model Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "color_code",
      label: "Color Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "color_name",
      label: "Color Name",
      show: "Y",
      editor: "text",
    },
  ]);
  // paket filter

  const [btnHide, setBtnHide] = useState(false);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      values[i].remove = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      const filteredShow = result.filter((item) => item.show === "Y");
      if (filteredShow.length <= 1) {
        setBtnHide(true);
      } else {
        setBtnHide(false);
      }

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });

    setTypeOptions(result);

    const filteredShow = result.filter((item) => item.show === "Y");
    if (filteredShow.length >= 1) {
      setBtnHide(false);
    } else {
      setBtnHide(true);
    }

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    setFields(values);
  };

  const handleSelectChange = (i, e) => {
    if (e === null) {
      e = undefined;
      const values = [...fields];
      values[i].value = "";
      setFields(values);
    } else {
      const values = [...fields];
      values[i].value = e.value;

      setFields(values);
    }
  };

  // paket filter bawah

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <div className="d-flex justify-content-between">
              <p className=" font-size-h3 text-title-primary font-weight-boldest">
                {dataParams}
              </p>
            </div>

            <div className="mb-5">
              <ThemeProvider theme={formLabelsTheme}>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Client"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.client.value}
                          readOnly
                          error={formValues.client.error}
                          helperText={
                            formValues.client.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowClient(true);
                                setGetDataClient(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.client.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["client"]: {
                                  ...formValues["client"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Shipper"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.shipper.value}
                          readOnly
                          error={formValues.shipper.error}
                          helperText={
                            formValues.shipper.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowShipper(true);
                                setTypeParty("SHIPPER");
                                setTypePartyName("Shipper");
                                setGetData(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.shipper.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["shipper"]: {
                                  ...formValues["shipper"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Consigne"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.consigne.value}
                          readOnly
                          error={formValues.consigne.error}
                          helperText={
                            formValues.consigne.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowShipper(true);
                                setTypeParty("CONSIGNEE");
                                setTypePartyName("Consigne");
                                setGetData(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.consigne.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["consigne"]: {
                                  ...formValues["consigne"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Workshop"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.workshop.value}
                          readOnly
                          error={formValues.workshop.error}
                          helperText={
                            formValues.workshop.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowShipper(true);
                                setTypeParty("MANUFACTURER");
                                setTypePartyName("Workshop");
                                setGetData(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.workshop.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["workshop"]: {
                                  ...formValues["workshop"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Factory"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.factory.value}
                          readOnly
                          error={formValues.factory.error}
                          helperText={
                            formValues.factory.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowShipper(true);
                                setTypeParty("MANUFACTURER");
                                setTypePartyName("Factory");
                                setGetData(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.factory.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["factory"]: {
                                  ...formValues["factory"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="Job Date From"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="job_date_start"
                          onChange={handleChange}
                          value={formValues.job_date_start.value}
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <p className="text-center mt-5">To</p>
                      </Col>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="Job Date Until"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="job_date_end"
                          onChange={handleChange}
                          value={formValues.job_date_end.value}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="ETD From"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="etd_start"
                          onChange={handleChange}
                          value={formValues.etd_start.value}
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <p className="text-center mt-5">To</p>
                      </Col>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="ETD Until"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="etd_end"
                          onChange={handleChange}
                          value={formValues.etd_end.value}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="ETA From"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="eta_start"
                          onChange={handleChange}
                          value={formValues.eta_start.value}
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <p className="text-center mt-5">To</p>
                      </Col>
                      <Col xs={12} sm={3} md={5} lg={5}>
                        <RedditTextField
                          label="ETA Until"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="eta_end"
                          onChange={handleChange}
                          value={formValues.eta_end.value}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </ThemeProvider>
            </div>

            {fields.map((field, idx) => {
              return (
                <div key={`${field}-${idx}`}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={2} className="ml-4 pr-0">
                      {idx === 0 && <b>Advance Search</b>}
                    </Form.Label>

                    <Col sm={3} className="pl-0">
                      {fields[idx].add === "N" && (
                        <Select
                          // isClearable={true}
                          options={data_filter}
                          value={getValueType(field.params, typeOptions)}
                          placeholder="Select Field"
                          // onChange={handleTypeChange}
                          onChange={(e) => handleTypeChange(idx, e)}
                        />
                      )}
                      {fields[idx].add === "Y" && (
                        <Form.Control
                          type="text"
                          value={fields[idx].label}
                          disabled
                        />
                      )}
                    </Col>
                    <Col sm={3}>
                      {field.editor === "text" && (
                        <Form.Control
                          type="text"
                          placeholder="Enter text"
                          value={field.value || ""}
                          onChange={(e) => handleRemarkChange(idx, e)}
                        />
                      )}
                      {field.editor === "status" && (
                        <Select
                          isClearable={true}
                          options={optionsStatus}
                          value={getValueType(field.value, optionsStatus)}
                          placeholder="Select Status"
                          // onChange={handleTypeChange}
                          onChange={(e) => handleSelectChange(idx, e)}
                        />
                      )}
                    </Col>
                    <Col sm={3} className=" m-0 p-0">
                      {field.params === "model_code" && (
                        <div
                          className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                          onClick={() => {
                            setShowModel(true);
                            setGetDataFilter(true);
                          }}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-light">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </div>
                      )}
                      {field.params === "color_code" && (
                        <div
                          className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                          onClick={() => {
                            setShowColor(true);
                            setGetDataFilter(true);
                          }}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-light">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </div>
                      )}
                      {field.params === "master_code" && (
                        <div
                          className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                          onClick={() => {
                            setShowProduct(true);
                            setGetDataFilter(true);
                          }}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-light">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </div>
                      )}
                      {fields[idx].remove === "Y" && (
                        <div
                          className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                          onClick={() => handleRemove(idx)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-light">
                            <SVG
                              src={toAbsoluteUrl("/media/svg/icons/New/X.svg")}
                            />
                          </span>
                        </div>
                      )}

                      {btnHide === false && fields.length - 1 === idx && (
                        <Button
                          className="mr-3"
                          variant="outline-primary"
                          onClick={(e) => handleAdd(idx, e)}
                        >
                          Add
                        </Button>
                      )}
                    </Col>
                  </Form.Group>
                </div>
              );
            })}

            <Row className="mt-6 justify-content-end">
              <Button
                className="mr-3 btn-filter"
                variant="primary"
                onClick={handleSearch}
              >
                Search
              </Button>
            </Row>

            <MonitorTable
              data={data === null ? [] : data}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              onTableChange={handleTableChange}
              loading={loading}
              handleSearch={handleSearch}
              dataParams={dataParams}
            />
          </CardBody>
        </Card>
      </div>

      <ModalClientRadio
        isOpen={showClient}
        setShow={setShowClient}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getDataClient}
        setGetData={setGetDataClient}
      />

      <ModalPartyRadio
        isOpen={showShipper}
        setShow={setShowShipper}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        typeParty={typeParty}
        setTypeParty={setTypeParty}
        typePartyName={typePartyName}
        setTypePartyName={setTypePartyName}
        getData={getData}
        setGetData={setGetData}
      />

      <ModalModelRadio
        isOpen={showModel}
        setShow={setShowModel}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getDataFilter}
        setGetData={setGetDataFilter}
      />
      <ModalProductRadio
        isOpen={showProduct}
        setShow={setShowProduct}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getDataFilter}
        setGetData={setGetDataFilter}
      />
      <ModalColorRadio
        isOpen={showColor}
        setShow={setShowColor}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getDataFilter}
        setGetData={setGetDataFilter}
      />
    </>
  );
};
